"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BracketParser = void 0;
var parser_1 = require("./parser");
Object.defineProperty(exports, "BracketParser", { enumerable: true, get: function () { return parser_1.BracketParser; } });
//# sourceMappingURL=index.js.map